import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import logo from './providers/custom-cat-new-logo.png';

const Img = styled.img`
    width: 100%;
`;

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 180px;
`;
export const CustomCatImage: FunctionComponent<{}> = () => <Img src={`${logo}`}></Img>;
const CustomCatLogo: FunctionComponent<{}> = () => (
    <LogoContainer>
        <CustomCatImage></CustomCatImage>
    </LogoContainer>
);

export default CustomCatLogo;
